import { Box, Container, Typography, Link } from '@mui/material';
import type { ReactNode } from 'react';

interface Props {
  title?: string;
  children: ReactNode;
}

export default function PublicToolLayout({ title, children }: Props) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #15549A 0%, #216FA4 48%, #46B8C2 100%)',
      }}
    >
      <Box
        component="header"
        sx={{
          bgcolor: 'rgba(255,255,255,.98)',
          borderBottom: '1px solid',
          borderColor: 'divider',
          py: 1.5,
          px: { xs: 2, md: 3 },
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          position: 'sticky',
          top: 0,
          zIndex: 10,
        }}
      >
        <Link href="/" underline="none" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography variant="h6" fontWeight={800} color="primary.main">
            Asneris
          </Typography>
        </Link>
        {title && (
          <>
            <Typography variant="body2" color="text.disabled">/</Typography>
            <Typography variant="body2" color="text.secondary">{title}</Typography>
          </>
        )}
      </Box>

      <Box component="main" sx={{ flex: 1, py: { xs: 3, md: 5 } }}>
        <Container
          maxWidth={false}
          sx={{
            width: '100%',
            maxWidth: 1180,
            mx: 'auto',
            px: { xs: 2, md: 3 },
            '& > h1, & > h2, & > h3, & > p': {
              color: 'white',
            },
            '& > .MuiTypography-root': {
              color: 'white',
            },
            '& > div': {
              backgroundColor: 'rgba(248, 251, 254, .97)',
              borderRadius: '16px',
              padding: { xs: 2, md: 3 },
              boxShadow: '0 18px 42px rgba(3, 31, 67, .16)',
            },
          }}
        >
          {children}
        </Container>
      </Box>

      <Box
        component="footer"
        sx={{
          py: 2,
          textAlign: 'center',
          bgcolor: 'rgba(8,55,108,.88)',
          color: 'rgba(255,255,255,.78)',
        }}
      >
        <Typography variant="caption" color="inherit">
          © {new Date().getFullYear()} Asneris · Free SEO diagnostics · Results are informational only.
        </Typography>
      </Box>
    </Box>
  );
}
